import React, { useEffect } from 'react'

import { HashRouter as Router, Routes, Route } from 'react-router-dom'

import routes from './routes'

const AppRoutes = () => {
  useEffect(() => {
    const evento = (e: { preventDefault: () => void }) => {
      e.preventDefault()
    }

    document.addEventListener('touchmove', evento, { passive: false })
    return () => document.removeEventListener('touchmove', evento)
  }, [])
  return (
    <Router basename="/">
      <Routes>
        {routes.map((route) => (
          <Route {...route} key={route.path[0]} />
        ))}
      </Routes>
    </Router>
  )
}
export default AppRoutes
